import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { moveCandidates } from 'ducks/concurrency'
import { getLocation } from 'ducks/router'
import { useCandidateGroupData, useModal, useSnackbar } from 'hooks'
import { jobs } from 'orm'

// one shared instance, so the memoized item is reused across renders
const getJob = jobs.getItem()

const useMoveCandidateGroupModalMutations = () => {
  const dispatch = useDispatch()

  const handleMoveCandidates = React.useCallback(
    ({ candidates, project, status }, { onShowSnackbar, onSuccess }) => {
      dispatch(
        moveCandidates(
          { candidates, project, status },
          { onShowSnackbar, onSuccess },
        ),
      )
    },
    [dispatch],
  )

  return {
    handleMoveCandidates,
  }
}

export const useMoveCandidateGroupModalState = () => {
  const {
    payload: { id },
  } = useSelector(getLocation)
  const position = useSelector(state => getJob(state, { pk: id }))

  const {
    state: { candidates, count, pks },
  } = useCandidateGroupData()

  return {
    state: {
      candidates,
      count,
      pks,
      position,
    },
  }
}

export const useMoveCandidateGroupModal = state => {
  const { candidates } = state

  const { isOpen, handleClose, handleOpen } = useModal()

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const { handleMoveCandidates } = useMoveCandidateGroupModalMutations()

  const handleConfirm = React.useCallback(
    ({ project, status }, { onSuccess }) => {
      handleMoveCandidates(
        { candidates, project, status },
        { onShowSnackbar: handleShowSnackbar, onSuccess },
      )
      handleClose()
    },
    [candidates, handleClose, handleMoveCandidates, handleShowSnackbar],
  )

  return {
    handleMoveCandidateGroupModalClose: handleClose,
    handleMoveCandidateGroupModalConfirm: handleConfirm,
    handleMoveCandidateGroupModalOpen: handleOpen,
    isMoveCandidateGroupModalOpen: isOpen,
  }
}
